import axios from "axios";

const API_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000/api";
const ACCESS_KEY = "barberiant_access";
const REFRESH_KEY = "barberiant_refresh";

export const tokenStore = {
  access: () => localStorage.getItem(ACCESS_KEY),
  refresh: () => localStorage.getItem(REFRESH_KEY),
  save: ({ access, refresh }) => {
    if (access) localStorage.setItem(ACCESS_KEY, access);
    if (refresh) localStorage.setItem(REFRESH_KEY, refresh);
  },
  clear: () => {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
  },
};

const api = axios.create({ baseURL: API_URL, timeout: 15000 });
let refreshing = null;

api.interceptors.request.use((config) => {
  const token = tokenStore.access();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    const refresh = tokenStore.refresh();
    if (error.response?.status !== 401 || original?._retry || !refresh || original?.url?.includes("auth/token/")) {
      return Promise.reject(error);
    }
    original._retry = true;
    try {
      refreshing ||= axios.post(`${API_URL}/auth/token/refresh/`, { refresh });
      const { data } = await refreshing;
      tokenStore.save({ access: data.access });
      original.headers.Authorization = `Bearer ${data.access}`;
      return api(original);
    } catch (refreshError) {
      tokenStore.clear();
      window.dispatchEvent(new Event("barberiant:logout"));
      return Promise.reject(refreshError);
    } finally {
      refreshing = null;
    }
  }
);

export const listData = (payload) => payload?.results || payload || [];
export const pageData = (payload) => ({
  count: payload?.count ?? listData(payload).length,
  next: payload?.next || null,
  previous: payload?.previous || null,
  results: listData(payload),
});

export const fetchAllPages = async (url, params = {}) => {
  const rows = [];
  let requestUrl = url;
  let requestParams = { page_size: 100, ...params };
  do {
    const { data } = await api.get(requestUrl, { params: requestParams });
    rows.push(...listData(data));
    requestUrl = data?.next || null;
    requestParams = undefined;
  } while (requestUrl);
  return rows;
};
export const apiError = (error, fallback = "No se pudo completar la operacion.") => {
  const data = error.response?.data;
  if (typeof data?.detail === "string") return data.detail;
  if (data && typeof data === "object") {
    const first = Object.values(data).flat()[0];
    if (first) return String(first);
  }
  return error.code === "ECONNABORTED" ? "El servidor tarda demasiado en responder." : fallback;
};

export default api;



